import {t} from "@lingui/core/macro";
import {StyleSheet} from "aphrodite";
import * as React from "react";
import {useHistory} from "react-router";

import Button from "@khanacademy/wonder-blocks-button";
import {View} from "@khanacademy/wonder-blocks-core";
import {Strut} from "@khanacademy/wonder-blocks-layout";
import {ModalLauncher, OnePaneDialog} from "@khanacademy/wonder-blocks-modal";
import {spacing} from "@khanacademy/wonder-blocks-tokens";
import {Body} from "@khanacademy/wonder-blocks-typography";
import {useQuery} from "@khan/data-gql";
import {
    GUIDE_ACKNOWLEDGEMENT_PROMO_NAME,
    USE_PROMOTION_QUERY,
    useAcknowledgeGuideTerms,
} from "@khan/guide-core";

export default function GuideTermsModal() {
    const history = useHistory();
    const acknowledgeGuideTerms = useAcknowledgeGuideTerms();
    const [closed, setClosed] = React.useState(false);

    const [result] = useQuery(USE_PROMOTION_QUERY, {
        variables: {promoName: GUIDE_ACKNOWLEDGEMENT_PROMO_NAME},
    });

    if (closed) {
        return null;
    }

    const isLoading = !result || result.status === "loading";
    if (isLoading) {
        // If we're still loading, bail out before rendering the modal.
        return null;
    }

    const hasAcknowledged =
        result.status === "success" && result.data.user?.promotion;
    if (hasAcknowledged) {
        // If the query tells us that the user has already accepted,
        // we can bail out.
        return null;
    }

    return (
        <ModalLauncher
            opened
            onClose={() => setClosed(true)}
            backdropDismissEnabled={false}
            modal={({closeModal}) => (
                <OnePaneDialog
                    title={t`You're the expert`}
                    closeButtonVisible={false}
                    style={styles.dialog}
                    content={
                        <View>
                            <Body>
                                {t`Khanmigo, like all AI, can make mistakes.`}
                            </Body>
                            <Strut size={spacing.large_24} />
                            <Body>
                                {t`These tools can save you hours per week, but ultimately you're the expert. Check over your work - Khanmigo needs your guidance.`}
                            </Body>
                            <Strut size={spacing.large_24} />
                            <Body>
                                {t`And if you see Khanmigo make a mistake, tap the Thumbs Down icon. It'll learn to get better!`}
                            </Body>
                        </View>
                    }
                    footer={
                        <View style={styles.footer}>
                            <Button
                                kind="tertiary"
                                onClick={() => history.goBack()}
                            >
                                {t`Go back`}
                            </Button>
                            <Strut size={spacing.large_24} />
                            <Button
                                testId="accept-guide-terms-button"
                                onClick={() => {
                                    acknowledgeGuideTerms();
                                    closeModal();
                                }}
                            >
                                {t`I understand`}
                            </Button>
                        </View>
                    }
                />
            )}
        />
    );
}

const styles = StyleSheet.create({
    dialog: {
        width: 480,
        height: 400,
    },
    footer: {
        flexDirection: "row",
    },
});
